import type { VoiceInputState } from "./voice-input.types";

export type VoiceInputEvent =
  | { type: "START_RECORDING" }
  | { type: "START_TRANSCRIBING" }
  | { type: "START_PROCESSING" }
  | { type: "COMPLETE" }
  | { type: "FAIL" }
  | { type: "DISMISS_ERROR" };

export const VoiceInputStateMachine = {
  transition(state: VoiceInputState, event: VoiceInputEvent): VoiceInputState {
    switch (event.type) {
      case "START_RECORDING":
        return state === "idle" || state === "error" ? "recording" : state;
      case "START_TRANSCRIBING":
        return state === "recording" ? "transcribing" : state;
      case "START_PROCESSING":
        return state === "transcribing" ? "processing" : state;
      case "COMPLETE":
        return "idle";
      case "FAIL":
        return "error";
      case "DISMISS_ERROR":
        return state === "error" ? "idle" : state;
      default: {
        const exhaustive: never = event;
        return exhaustive;
      }
    }
  },
} as const;
